<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small :title="'گزارش صورتحساب های صادر شده از طریق کیف پول'" color="accent">

			<AgentFactors ref="agentFactor" @edit="edit" @remove="remove" userType='member' :autoSubmit="true" :hideDateRange="true" />

			<v-dialog v-model="dialogModify" scrollable max-width="500px">
				<AgentFactorModify v-if="dialogModify" @close="dialogModify = false" @print="print" :data="selectedItem" userType='member' />
			</v-dialog>

		</material-card>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import AgentFactors from '@/components/forms/AgentFactors.vue'

	export default {
		name: 'AgentFactorsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AgentFactorModify: () => import('@/components/forms/AgentFactorModify'),
			AgentFactors: AgentFactors
		},
		data() {
			return {
				selectedItem: null,
				dialogModify: false
			}
		},
		mounted() {
		},
		methods: {
			edit(item) {
				this.selectedItem = item
				this.dialogModify = true
			},
			remove(item) {

			},
			print(item) {
				this.$refs.agentFactor.print(item)
			}
		},
	}
</script>
<style></style>
